module.exports = __webpack_public_path__ + "static/funamoto_takuto-1879d3ed7492460999ba786744761b27.jpg";